export default [
  {
    path: '/app/teams',
    name: 'Teams',
    component: () => import('@/views/Teams/Index.vue'),
    meta: {
      pageTitle: 'nav.teams',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
      resource: 'TEAM_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/teams/add',
    name: 'TeamsAdd',
    component: () => import('@/views/Teams/Add.vue'),
    meta: {
      pageTitle: 'nav.teams',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/teams',
          active: false,
        },
        {
          text: 'breadcrumb.create',
          active: true,
        },
      ],
      resource: 'TEAM_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/teams/edit/:id',
    name: 'TeamsEdit',
    component: () => import('@/views/Teams/Edit.vue'),
    meta: {
      pageTitle: 'nav.teams',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/teams',
          active: false,
        },
        {
          text: 'breadcrumb.update',
          active: true,
        },
      ],
      resource: 'TEAM_EDIT',
      action: 'read',
    },
  },
]
